import { AnimatePresence } from 'framer-motion';
// Imported from each store's own module rather than its feature barrel: the
// barrels also re-export the (large, lazy-loaded) modal component, and
// pulling in even a named store export from the same module drags that
// component into this always-mounted, non-lazy component's bundle too (see
// Sentry WEB-CLIENT-284 et al, "Large Render Blocking Asset").
import { useCreateScheduleModalStore } from '@/pages/Dashboard/components/CreateScheduleModal/store';
import { useAddContentModalStore } from '@/pages/Schedule/components/AddContentModal/store';
import { useOnboardingModalStore } from '@/pages/Schedule/components/OnboardingModal/store';
import { useDraftEntryStore } from '@/pages/Schedule/stores';
import { fadeConfig, MotionBox } from '@/ui';

export const SharedModalOverlay = () => {
  const { isOpen: isCreateScheduleModalOpen } = useCreateScheduleModalStore();
  const { isOpen: isAddContentModalOpen } = useAddContentModalStore();
  const { isOpen: isOnboardingModalOpen } = useOnboardingModalStore();
  const isEntryModalOpen = useDraftEntryStore(
    (store) => Boolean(store.draftEntry) && store.draftComposer === 'modal'
  );

  const renderSharedModalOverlay =
    isCreateScheduleModalOpen ||
    isAddContentModalOpen ||
    isOnboardingModalOpen ||
    isEntryModalOpen;

  return (
    <AnimatePresence>
      {renderSharedModalOverlay && (
        <MotionBox
          bg="blackAlpha.600"
          h="100vh"
          inset="0"
          pos="fixed"
          w="100vw"
          zIndex="modal"
          {...fadeConfig}
        />
      )}
    </AnimatePresence>
  );
};
